import React from "react";
import confettiImg from "../../../../assets/v2-ending-confetti.png";

interface V2EndingConfettiProps {
  width?: number;
  className?: string;
}

const CONFETTI_ASPECT = 248 / 716;

/** 结束页庆祝彩带 — 设计稿 矩形@2x.png */
const V2EndingConfetti: React.FC<V2EndingConfettiProps> = ({
  width = 358,
  className,
}) => {
  const height = Math.round(width * CONFETTI_ASPECT);

  return (
    <img
      src={confettiImg}
      alt=""
      aria-hidden
      width={width}
      height={height}
      className={className}
      draggable={false}
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width,
        height,
        pointerEvents: "none",
        userSelect: "none",
      }}
    />
  );
};

export default V2EndingConfetti;
